import { FC } from 'react';
import { UserProfile } from '@features/users';
import { Box } from '@mui/material';

interface TableUserViewProps {
    userId: number;
    showPopover?: boolean;
}

const UserTableView: FC<TableUserViewProps> = ({ userId, showPopover }) => (
    <Box onClick={(e) => e.stopPropagation()}>
        {userId ? (
            <UserProfile
                createdUserId={userId}
                showAvatar
                popoverInfo={
                    showPopover
                        ? {
                              avatar: true,
                              email: true,
                              profileLink: true,
                              rocket: true,
                              role: true,
                          }
                        : undefined
                }
                userContainerProps={{
                    sx: { border: 'none', gap: '2px', margin: 0 },
                }}
            />
        ) : (
            '–'
        )}
    </Box>
);

export default UserTableView;
